// extracted by mini-css-extract-plugin
export var scrollArea = "_na-0";